import React from 'react'

import * as sharedStyles from 'common/builder/components/chart/FlowChart/nodes/shared/styles'
import { toPx } from 'common/builder/components/chart/utils/toPx'

export const Separator: React.CSSProperties = {
  height: toPx(sharedStyles.Spacings.MEDIUM),
}

export const DelayBlock: React.CSSProperties = {
  paddingTop: 0,
  paddingBottom: 0,
}

export const NextStepWrapper: React.CSSProperties = {
  ...sharedStyles.row,
  justifyContent: 'flex-end',
  marginTop: toPx(sharedStyles.Spacings.NEXT_STEP_VERTICAL_MARGIN),
  marginRight: toPx(sharedStyles.Spacings.NODE_HORIZONTAL_PADDING * -1),
}

export const NextStep: React.CSSProperties = {
  margin: 0,
}

export const NextStepIcon: React.CSSProperties = {
  width: toPx(sharedStyles.IconSizes.MEDIUM),
  height: toPx(sharedStyles.IconSizes.MEDIUM),
  marginRight: toPx(2),
}

export const QuickRepliesRow: React.CSSProperties = {
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
}

export const QuickRepliesSpacer: React.CSSProperties = {
  width: toPx(sharedStyles.Spacings.SMALL),
}

export const QuickReplyButton: React.CSSProperties = {
  marginBottom: toPx(sharedStyles.Spacings.BLOCK_VERTICAL_SPACING),
}
